import { useEffect, useRef, useState } from "react";
import { Avatar, Layout, Menu } from "antd";
import {
  DownOutlined,
  UserOutlined,
  UnlockOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import ChangePassword from "../../Modal/ChangePassword";
import * as Utils from "../../utils/helper/utils";
import * as Auth from "../../utils/helper/auth";
import Logout from "../../Modal/Logout";
import { useSocketContext } from "../../context/SocketContext";
import toast from "react-hot-toast";
import EnableNotification from "../../Modal/EnableNotification";

const { Header } = Layout;
const HeaderComponent = () => {
  const [isEnableNotificationModel, setEnableNotificationModel] =
    useState(true);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [name, setName] = useState("");
  const showChangePasswordModal = () => {
    setIsChangePasswordModalOpen(true);
  };
  const handleChangePasswordOk = () => {
    setIsChangePasswordModalOpen(false);
  };
  const handleChangePasswordCancel = () => {
    setIsChangePasswordModalOpen(false);
  };
  const showLogoutModal = () => {
    setIsLogoutModalOpen(true);
  };
  const handleLogoutOk = () => {
    localStorage.removeItem("redirectAfterLogin"); // Clean up
    setIsLogoutModalOpen(false);
    Utils.clearLocalData();
    window.location.reload();
  };
  const handleLogoutCancel = () => {
    setIsLogoutModalOpen(false);
  };

  useEffect(() => {
    let adminName = Auth.authData();
    adminName = adminName?.user?.firstName + " " + adminName?.user?.lastName;
    setName(adminName);
  }, []);

  const audioRef = useRef(null);
  const enableAudioPlayback = () => {
    const audio = new Audio("/audio/notification.mp3"); // Replace with your file path
    audioRef.current = audio;
    //console.log("Audio preloaded and ready to play.");
  };
  const playSound = () => {
    if (audioRef.current) {
      audioRef.current
        .play()
        .then(() => {
          //console.log("Audio playback started.");
        })
        .catch((error) => {
          //console.error("Audio playback failed:", error);
        });
    } else {
      //console.log("Audio is not loaded. Call enableAudioPlayback first.");
    }
  };

  const { socket } = useSocketContext();
  useEffect(() => {
    if (!socket) return;
    //update state to send new notification in the list
    let notificationFunction = (data) => {
      toast.success(data.message, {
        duration: 2000,
      });
      playSound();
    };

    //setting All Events
    socket.on("welcome", notificationFunction);
    socket.on("NewOrderCreated", notificationFunction);
    socket.on("customerAcceptOrder", notificationFunction);
    socket.on("customerRejectOrder", notificationFunction);
    socket.on("QcRequestSubmitted", notificationFunction);
    socket.on("QCAcceptedOrder", notificationFunction);
    socket.on("QCRejectedOrder", notificationFunction);
    socket.on("QCApproveItemRequest", notificationFunction);
    socket.on("QCRejectItemRequest", notificationFunction);

    return () => {
      socket.off("welcome");
    };
  }, [socket]);

  const handelEnableNotificationModelOk = () => {
    enableAudioPlayback();
    setEnableNotificationModel(false);
  };
  const handelEnableNotificationModelCancel = () => {
    setEnableNotificationModel(false);
  };

  return (
    <>
      <div>
        <Header
          style={{ background: "#fff", padding: "0px 16px" }}
          className="sticky top-0 z-50"
        >
          <div className="text-right">
            <Menu mode="horizontal" className="ml-auto flex justify-end">
              <Menu.SubMenu
                key="SubMenu"
                title={
                  <>
                    <span
                      className="cursor-pointer inline-block"
                      onClick={(e) => e.preventDefault()}
                    >
                      <Avatar size={40} icon={<UserOutlined />} />
                      <span className="mx-2">{name}</span>
                      <DownOutlined />
                    </span>
                  </>
                }
              >
                <Menu.Item>
                  <UserOutlined className="mr-1" /> Profile
                </Menu.Item>
                <Menu.Item onClick={showChangePasswordModal}>
                  <UnlockOutlined className="mr-1" /> Change Password
                </Menu.Item>
                <Menu.Item onClick={showLogoutModal}>
                  <LoginOutlined className="mr-1" /> Logout
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </div>
        </Header>
        <ChangePassword
          isOpen={isChangePasswordModalOpen}
          onOk={handleChangePasswordOk}
          onCancel={handleChangePasswordCancel}
        />
        <Logout
          ConfirmationHeading="Logout"
          ConfirmationParagraph="Are you sure you want to logout?"
          isOpen={isLogoutModalOpen}
          onOk={handleLogoutOk}
          onCancel={handleLogoutCancel}
        />
        {isEnableNotificationModel && (
          <EnableNotification
            isOpen={isEnableNotificationModel}
            onOk={handelEnableNotificationModelOk}
            onCancel={handelEnableNotificationModelCancel}
          />
        )}
      </div>
    </>
  );
};
export default HeaderComponent;
